export default __webpack_public_path__ + "static/media/011-alpaca.3cac839d.svg";